import { DoubleSide } from 'three';
import Model from './Model';

class Ghost extends Model {
  constructor() {
    super('ghost', {
      textures: {
        eyes: ['map'],
        body: ['map'],
      },
      configuration: {
        side: DoubleSide,
      },
    });
  }
}

export default new Ghost();
